const legacyOnlyPaths = new Set([
  '/admin/users', '/personas', '/categories', '/ai-models', '/ai-model-providers',
  '/ai-model-ai-providers', '/visibility-weights', '/products', '/prompt-funnel-stages',
  '/line-of-biz-dashboard', '/report-instances', '/report-instance-weights', '/prompts',
  '/prompt-sets', '/tenant-organizations-brands', '/line-of-biz-categories',
  '/line-of-biz-personas', '/competitor-brands', '/custom-views',
]);

function legacyRecoveryPath(path: string) {
  // Match only routes owned by the legacy router. Its :id accepts one segment.
  if (!path.startsWith('/') || path.startsWith('//')) return;
  try {
    if (/[\\\u0000-\u001f\u007f]/.test(decodeURIComponent(path))) return;
  } catch {
    return;
  }
  const normalized = path.replace(/\/$/, '');
  if (legacyOnlyPaths.has(normalized)) return path;
  if (/^\/report-templates\/[^/]+$/.test(normalized)) return `${normalized}/prompts`;
  if (/^\/(?:lines-of-business|report-instances|prompt-sets|custom-views)\/[^/]+\/?$/.test(path)
    || /^\/report-templates\/[^/]+\/(?:settings|prompts|instances|visibility)\/?$/.test(path)) return path;
}

/** Resolve once at boot: each interface owns its router base and theme. */
export function resolveUiEntry(pathname: string, baseUrl: string, location: { search?: string; hash?: string } = {}) {
  const base = `/${baseUrl.split('/').filter(Boolean).join('/')}`.replace(/\/$/, '');
  const legacyBase = `${base}/oldui`;
  const legacyPath = pathname === legacyBase || pathname.startsWith(`${legacyBase}/`);
  const localPath = base ? (pathname.startsWith(`${base}/`) ? pathname.slice(base.length) : '') : pathname;
  const recovery = !legacyPath ? legacyRecoveryPath(localPath) : undefined;
  return {
    ...(recovery ? { redirectHref: `${legacyBase}${recovery}${location.search ?? ''}${location.hash ?? ''}` } : {}),
    legacy: legacyPath,
    basename: legacyPath ? legacyBase : base,
    legacyHref: `${legacyBase}/`,
    newHref: `${base}/`,
  };
}

/** Preserve query/hash through sign-in, and reject external return targets. */
export function loginReturnPath(from?: { pathname?: string; search?: string; hash?: string }) {
  const path = from?.pathname;
  if (!path?.startsWith('/') || path.startsWith('//') || /[\\\u0000-\u001f]/.test(path)) return '/';
  return `${path}${from?.search ?? ''}${from?.hash ?? ''}`;
}
